module.exports = __webpack_public_path__ + "img/task-main-left-background.4512b8c0.png";